export enum EQuestionAction {
    delete,
    requierd,
    addToCollection, 
    saveList,
    chooseAsFilterField,
    chooseAsAutoFillField,
    editAsAutoFillField,
    removeAsAutoFillField,
    removeAsFilterField,
    addToApiExposureCollectionFields,
    editToApiExposureCollectionFields,
}